import React, { useState, useEffect } from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './blog.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { blogById } from "../../api/blog"
import { useParams } from "react-router-dom"
import { getImageUrl } from "../../utils/imageUrl"
// -------------------------------------------------

const BlogDetail = () => {
  const params = useParams()
  const [blogDetail, setBlogDetail] = useState('')

  const getData = async () => {
    const resp = await blogById(params?.id)
    setBlogDetail(resp?.data)
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <>
      <Header />
      <section className='specialOffers'>
        <div className='container'>
          <div className="row g-4 g-xl-5 justify-content-center blogs">
            <div className="col-md-8">
              <div className="card bg-transparent">
                <img src={getImageUrl(blogDetail?.images && blogDetail?.images[0])} className="card-img" alt="" />
                <div className="card-body px-3">
                  <h4>{blogDetail?.title}</h4>
                  <ul class="nav nav-divider align-items-center pb-3">
                    <li class="nav-item">{new Date(blogDetail?.createdAt)?.toLocaleDateString()}</li>
                    <li class="nav-item">{blogDetail?.topics?.map((item) => item)}</li>
                  </ul>
                  <div className="blog-content" dangerouslySetInnerHTML={{ __html: blogDetail?.content }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default BlogDetail
